﻿import React, { Fragment, useState, useEffect } from 'react';
import { Intent } from '@blueprintjs/core'
import { FormHelperText, FormPasswordConfirm } from "components/form-fields";
import { LoginLayout } from 'pages/layouts';
import { ShowHide } from 'components/layout';
import { ButtonSave } from 'components/buttons';
import { useValidation } from "hooks/useValidation";
import { UserService } from 'services';
import { NotificationToaster } from "components/notifications";
import { useQuery } from 'hooks/useQuery';

export function ForgotPasswordConfirm() {

    const [reset, setReset] = useState(false);
    const [saving, setSaving] = useState(false);
    const query = useQuery();
    const userId = query.get("u");
    const resetCode = query.get("r");

    const [confirmRequest, setConfirmRequest] = useState({
        password: '',
        resetGuid: resetCode
    });
    const [passwordsMatch, setPasswordsMatch] = useState(false);
    const [passwordCriteriaMet, setPasswordCriteriaMet] = useState(false);
    const [isValid, errors, validate] = useValidation();

    const rules = [
        { fieldName: "password", required: true }
    ];

    function onPasswordChange(password, matching, criteriaMet) {
        setPasswordsMatch(matching);
        setPasswordCriteriaMet(criteriaMet);
        setConfirmRequest({
            ...confirmRequest,
            password: password
        });
    }

    function confirmUser() {
        if (isValid && passwordsMatch && passwordCriteriaMet && saving) {
            UserService.resetPassword(userId, confirmRequest).then(function () {
                setSaving(false);
                setReset(true);
            }, function (error) {
                setSaving(false);
                const badRequestCode = 400;
                if (error && error.status === badRequestCode) {
                    NotificationToaster.show(Intent.WARNING, "Reset code is either invalid or has expired.");
                } else {
                    NotificationToaster.show(Intent.DANGER, "Could not reset your password, please try again.");
                }
            });
        }
        else {
            setSaving(false);
        }
    }

    function validateForm() {
        setSaving(true);
        validate(rules, confirmRequest, [{ fieldName: "password", valid: passwordCriteriaMet, errorMessage: "Your password does not meet the minimum requirements" }]);
    }

    useEffect(confirmUser, [isValid, saving]);

    return (
        <LoginLayout>

            <ShowHide
                evaluator={!reset}
                show={(
                    <Fragment>
                        <h2>Reset your password</h2>

                        <FormPasswordConfirm
                            id="password-confirm"
                            value={confirmRequest.password}
                            onChange={onPasswordChange}
                            dangerHelperText={errors.password}
                        />

                        <ButtonSave
                            onClick={validateForm}
                            disabled={saving}
                            text="Reset password"
                            icon={null}
                            simpleDisabled={!passwordsMatch}
                        ></ButtonSave>

                    </Fragment>
                )}
                hide={(
                    <Fragment>
                        <h2>Password has been successfully reset</h2>

                        <FormHelperText>
                            <p><a href={window.env.VISION_URL}>Login to Vision</a>.</p>
                        </FormHelperText>
                    </Fragment>
                )}

            />

        </LoginLayout>
    );

}